var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSessions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 6.44444H7.25V7.44444H8.25V6.44444ZM8.25 1H9.25C9.25 0.574069 8.98021 0.194882 8.57781 0.0552571C8.17542 -0.0843683 7.72874 0.0462144 7.46492 0.380604L8.25 1ZM1.5 9.55556L0.714922 8.93616C0.477579 9.23699 0.433009 9.64699 0.600168 9.99179C0.767326 10.3366 1.11682 10.5556 1.5 10.5556L1.5 9.55556ZM6.75 9.55556H7.75V8.55556H6.75V9.55556ZM6.75 15H5.75C5.75 15.4259 6.01979 15.8051 6.42219 15.9447C6.82458 16.0844 7.27126 15.9538 7.53508 15.6194L6.75 15ZM13.5 6.44444L14.2851 7.06384C14.5224 6.76301 14.567 6.35301 14.3998 6.00821C14.2327 5.66341 13.8832 5.44444 13.5 5.44444V6.44444ZM9.25 6.44444V1H7.25V6.44444H9.25ZM7.46492 0.380604L0.714922 8.93616L2.28508 10.175L9.03508 1.6194L7.46492 0.380604ZM1.5 10.5556H6.75V8.55556H1.5V10.5556ZM5.75 9.55556V15H7.75V9.55556H5.75ZM7.53508 15.6194L14.2851 7.06384L12.7149 5.82505L5.96492 14.3806L7.53508 15.6194ZM13.5 5.44444H8.25V7.44444H13.5V5.44444Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessions);
export default __webpack_public_path__ + "static/media/sessions.91388ce0e11f9067213efac0e1fd6fb0.svg";
export { ForwardRef as ReactComponent };